import React from 'react'
import {Link} from 'react-router-dom'

import { Card, CardActions, CardContent, Button, Avatar, Grid, Chip } from '@material-ui/core';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined'
import PeopleOutlineOutlinedIcon from '@material-ui/icons/PeopleOutlineOutlined'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'


import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'
import investorsImg from 'img/imgs/investors.svg'
// import investorsImg from '../imgs/investors.svg';

const validateValue = (value) => value !== undefined && value !== null && value !== '';

const GetSkills = ({ user }) => {
  if (typeof user.skills !== 'string' || user.skills.trim() === '') {
    return null;
  }
  
  const skillsArray = user.skills?.trim().split(",");

  return (
    <>
      {skillsArray.map((skill) => (
        <Chip key={skill} label={skill} />
      ))}
    </>
  );
};

export const BenchUserCard = ({ user, classes, }) => {

  const ROUTES = NavigationService.getRoutes()
  const detailbenchPath = ROUTES[pages.BENCHUSERDETAILS].path.replace(":email",user?.id);

  return (
    <Card className={classes.benchCard}>
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={3} container justifyContent="center" alignItems="center">
            <Avatar src={user.photo} alt={user.name} aria-hidden="true">
              {!user.photo && user.name ? user.name.charAt(0).toUpperCase() : null}</ Avatar>
          </Grid>
          <Grid item xs={12} md={9} className={classes.benchCard_nameContainer}>
            <h3 className={classes.benchCard_title}>{validateValue(user.fullname) ? user.fullname : 'No name available'}</h3>
            <p>{ validateValue(user.jobTitle) ? user.jobTitle : 'No job title available' }</p>
          </Grid>
        </Grid>

        <div className={classes.benchCard_informationContainer}>
          <span>
            <EmailOutlinedIcon aria-hidden="true" />
            <span>{ validateValue(user.id) ? user.id : 'No email available' }</span>
          </span>
          <span>
            <PeopleOutlineOutlinedIcon aria-hidden="true" />
            <span>{ validateValue(user.division) ? user.division : 'No division available' }</span>
          </span>
        </div>

        <Grid container xs={12} md={12} className={classes.benchCard_chipStyle}>
          { GetSkills({ user }) }
        </Grid>
      </CardContent>

      <CardActions>
        <Button endIcon={<ArrowForwardIcon aria-hidden="true" />} href={detailbenchPath}>
          View More
        </Button>
      </CardActions>
    </Card>
  )
}